import { render, staticRenderFns } from "./CoordinatesAndOrientation.vue?vue&type=template&id=46e1fbd0&"
import script from "./CoordinatesAndOrientation.vue?vue&type=script&lang=js&"
export * from "./CoordinatesAndOrientation.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatesAndOrientation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports